import { GetGroupMessagesResponse } from '@/models/GroupChatMessage';
import { apiClient } from '@/services/api';

export async function getGroupChatMessages(
  groupId: string,
  cursor?: string,
): Promise<GetGroupMessagesResponse> {
  const params = new URLSearchParams();
  if (cursor) params.set('cursor', cursor);
  const url = `/client-groups/${encodeURIComponent(groupId)}/chat/messages${
    params.toString() ? `?${params}` : ''
  }`;
  const response = await apiClient.get<GetGroupMessagesResponse>(url);
  return response.data;
}

export async function markGroupAsRead(groupId: string): Promise<void> {
  await apiClient.post(`/client-groups/${encodeURIComponent(groupId)}/chat/mark-read`);
}

export async function generateChatAttachmentUrl(groupId: string, s3Key: string): Promise<string> {
  const url = `/client-groups/${encodeURIComponent(groupId)}/chat/attachment-url`;
  const response = await apiClient.post<{ url: string }>(url, { s3Key });
  return response.data.url;
}
